import React, { useEffect, useState } from "react";
import CustomModal from "../../../components/Modal";
import { useForm } from "react-hook-form";
import { AssignContainerFormValues } from "../../../service/interfaces/Forms";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../../components/FormInputs";
import DatePicker from "../../../components/Datepicker";
import CustomDropDown from "../../../components/Dropdown/CustomDropDown";
import FormTitle from "../../../components/FormTitle";
import { validationSchema } from "../../../service/validation/Surveyor";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import PhoneInput from "../../../components/phoneinput";
import { SurveyorFormData } from "../../../service/interfaces/props.interface";
import { useNavigate, useParams } from "react-router-dom";
import { ApiService } from "../../../service/api.service";
import { MASTER_URL } from "../../../common/common";

interface AssignContainerProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id?: any;
  onSuccess?: () => void;
}

const Managesurveyor: React.FC<AssignContainerProps> = ({ open, setOpen, id, onSuccess }) => {
  console.log("ID", id);
  const apiService = new ApiService();
  const navigate = useNavigate();
  const [data, setData] = useState<any>(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    reset,
    watch,
    control,
    setValue,
  } = useForm<SurveyorFormData>({
    resolver: yupResolver(validationSchema) as any,
  });

  const cancel = () => {
    setOpen(false);
  };

  const getData = async () => {
    const response: any = await apiService.getApi(`${MASTER_URL}/surveyor/get-one-route?surveyorId=${id}`,)
    if (response.status === "200") {
      const data = response.body
      // Map backend response to frontend form structure
      const formData = {
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        phoneNumber: data.contactNumber || '',
        Location: data.location || '',
        activeInactive: true
      };
      setData(formData);
    }
  }
  useEffect(() => {
    if (id) {
      getData()
    }
  }, [id])

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data, reset]);

  const onSubmit = async (data: SurveyorFormData) => {
    try {
      console.log("Form Data:", data);
      if (!data) return;

      // Map frontend form data to backend expected structure
      const payload: any = {
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNumber: data.phoneNumber,
        Location: data.Location,
        activeInactive: { activeInactive: data.activeInactive },
        email: null
      };

      if (id) {
        payload.surveyorId = id;
      }

      const response: any = id
        ? await apiService.putApi(`${MASTER_URL}/surveyor/edit-route`, payload)
        : await apiService.postApi(`${MASTER_URL}/surveyor/register-route`, payload);

      console.log(response, "response");

      if (response.status === "200") {
        reset();
        setOpen(false);
        onSuccess?.();
      } else {
        console.warn("Surveyor submission failed");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  return (
    <div>
      <CustomModal
        isOpen={open}
        title="Add Surveyor"
        width="900px"
        titleColor="#444FBD"
        onClose={() => setOpen(false)}
        content={
          <div>
            <form
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className=" gap-4">
                <div className="grid grid-cols-2 gap-4 pt-8  w-full  border-[#C1C1C1] pr-4">
                  <Input
                    register={register}
                    name="firstName"
                    errors={errors}
                    label="FirstName"
                    placeholder="First Number"
                    type="text"
                    onBlur={() => trigger("firstName")}
                  />
                  <Input
                    register={register}
                    name="lastName"
                    errors={errors}
                    label="LastName"
                    placeholder="Last Number"
                    type="text"
                    onBlur={() => trigger("lastName")}
                  />
                  <PhoneInput
                    control={control}
                    name="phoneNumber"
                    errors={errors}
                    label="Phone Number"
                    placeholder="Enter phone number"
                    defaultCountry="IN"
                    maxLength={10}
                  />
                  <Input
                    register={register}
                    name="Location"
                    errors={errors}
                    label="Location"
                    placeholder="Location"
                    type="text"
                    onBlur={() => trigger("Location")}
                  />
                </div>
                <br />
                <ToggleSwitch
                  name="activeInactive"
                  label="Active/Inactive"
                  errors={errors}
                  register={register}
                />
              </div>
              <div className="flex gap-4 justify-end mt-4">
                <button
                  type="button"
                  onClick={cancel}
                  className="w-36 h-10 rounded-lg text-[#444FBD] border border-[#444FBD] hover:border-gray-400 transition duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-36 h-10 rounded-lg bg-[#444FBD] text-white transition duration-200"
                >
                  Submit
                </button>
              </div>

            </form>
          </div>
        }
      />
    </div>
  );
};

export default Managesurveyor;
